<pas-tabset>
  <pas-tab>
    <ng-template pasTabTitle>
      <b>{{ 'APPROVAL_TAB_TITLE' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <div id="grid-wrapper" style="width: 100%">
        <ag-grid-angular
          [domLayout]="'normal'"
          [style.height]="approvalsOverviewData.length > 20 ? '750px' : 'none'"
          [gridOptions]="gridOptions"
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [multiSortKey]="multiSortKey"
          [components]="frameworkComponents"
          [getContextMenuItems]="getContextMenuItems"
          [tooltipShowDelay]="tooltipShowDelay"
          [enableBrowserTooltips]="true"
          [excelStyles]="excelStyles"
          (gridReady)="onGridReady($event)"
          class="ag-theme-alpine_customize"></ag-grid-angular>
      </div>
    </ng-template>
  </pas-tab>
</pas-tabset>

<pas-sidebar-holder [hasNavbar]="true">
  <div class="sidebar-contents">
    <ng-container>
      <div class="sidebar-element sidebar-row">
        <ul class="navbar-nav">
          @if (aftersalesBookingsToApprove | canUserApproveAutomatedAftersalesBookings) {
            <li class="nav-item">
              <a (click)="approveAllAutomatedAftersalesBookings()" class="nav-link link-sidebar">
                <i class="material-icons">check</i>
                <span class="hidden-md-down" ui-test-id="approveAutomatedAftersalesBookingsBtn">
                  {{ 'APPROVE_AUTOMATED_AFTERSALES_BOOKINGS' | translate }}
                </span>
              </a>
            </li>
          }
          @if (recourseBookingsToApprove | canUserApproveAutomatedRecourseBookings) {
            <li class="nav-item">
              <a (click)="approveAllAutomatedRecourseBookings()" class="nav-link link-sidebar">
                <i class="material-icons">check</i>
                <span class="hidden-md-down" ui-test-id="approveAutomatedRecourseBookingsBtn">
                  {{ 'APPROVE_AUTOMATED_RECOURSE_BOOKINGS' | translate }}
                </span>
              </a>
            </li>
          }
          <li [ngClass]="isCreateExcelApprovalEnabled ? 'nav-item' : 'nav-item disabled'">
            <a (click)="onBtnCreateExcelApproval()" class="nav-link link-sidebar">
              <i class="material-icons">get_app</i>
              <span class="hidden-md-down" ui-test-id="excelExportBtn">{{ 'EXCEL_EXPORT' | translate }}</span>
            </a>
          </li>

          <app-tva-session-sidebar></app-tva-session-sidebar>
        </ul>
      </div>
    </ng-container>
  </div>
</pas-sidebar-holder>

<approve-reject-reprocess-dialog></approve-reject-reprocess-dialog>
